import { ApiRoute } from 'api-base-refrence';
import { ApiApiRoute } from 'app/api-route/api/api.api';

export class HomePageApiRoute extends ApiRoute {
  static apiName = 'site_management__home';
  static parent = ApiApiRoute;
  static urlPattern() {
    return `/home`;
  }
}
